/* Pro Witgoed — het verlanglijstje.
 *
 * WAAR HET LIJSTJE STAAT, EN WAAROM DAAR
 * In localStorage van de bezoeker. Niet als armoedige tussenoplossing maar omdat het niet anders
 * kan én omdat het hoort: verreweg de meeste bezoekers zijn niet ingelogd, en voor hen bestaat er
 * geen klantmetaveld om iets in te zetten. Een verlanglijstje dat pas werkt na inloggen is een
 * verlanglijstje dat bijna niemand gebruikt.
 *
 * EN VOOR EEN INGELOGDE KLANT OOK BIJ DE KLANT ZELF
 * Dan staat hetzelfde lijstje in het klantmetaveld pws.verlanglijst, zodat het meereist naar zijn
 * telefoon en straks in een e-mailflow gebruikt kan worden. snippets/pws-verlanglijst-account.liquid
 * zet dat lijstje en een ondertekend token in de pagina; koppel() hieronder voegt de twee samen en
 * duwen() schrijft elke wijziging terug naar de server. Zonder sleutel in de thema-instellingen
 * gebeurt daar niets van en werkt alles gewoon zoals hiervoor.
 *
 * WAAROM ER ZOWEL EEN ID ALS EEN HANDLE WORDT BEWAARD
 * Ophalen gaat met /products/<handle>.js, dus de handle is nodig. Maar handles zijn per taal
 * anders — dat is in deze winkel al eerder stukgelopen. Het id staat er daarom bij: dat is per
 * taal hetzelfde, dus het id is de sleutel en de handle niet meer dan een hulpmiddel dat de
 * lijstpagina zelf herstelt zodra hij niet meer klopt (zie bijwerken()).
 *
 * ALLES IN EEN TRY/CATCH
 * localStorage gooit in een privévenster en bij geblokkeerde cookies. Een verlanglijstje mag geen
 * productpagina slopen, dus elke lees- en schrijfactie is afgeschermd en valt terug op een lege lijst.
 *
 * TERUG-NAVIGATIE (bfcache)
 * Ga je van het lijstje naar een product, klik je daar het hartje aan en druk je op Terug, dan komt
 * de vorige pagina uit de bfcache terug: DOMContentLoaded vuurt niet, dus zonder extra maatregel
 * staat er een hartje "gevuld" terwijl de opslag iets anders zegt — en dan doet een klik het
 * omgekeerde van wat er staat. Het thema heeft hier een afspraak voor (main.js vuurt
 * on:bfcache:load-restore), en daar luisteren we naar, plus naar pageshow zelf voor de zekerheid.
 */
(function () {
  var SLEUTEL = 'pw_verlanglijst';
  var GEBEURTENIS = 'pw:verlanglijst';
  var WEG_SLEUTEL = 'pw_verlanglijst_weg';
  var METING_URL = 'https://seo.merkatura.nl/api/verlanglijst/meting';
  /* WELKE WINKEL DIT IS.
     Pro Witgoed en Pro Cooking draaien hetzelfde bestand op verschillende thema's. Het thema zet
     window.PWVL_WINKEL; staat er niets, dan is het Pro Witgoed — die winkel had het eerst en
     hoefde daarvoor niet aangepast te worden. De server kiest op deze naam de sleutel waarmee
     het token is ondertekend, dus een verkeerde naam betekent een geweigerd verzoek en geen
     verkeerd weggeschreven lijstje. */
  var WINKEL = window.PWVL_WINKEL || 'pro-witgoed';

  /* ---- tellen dat er geklikt is -------------------------------------------------------------
     WAAROM DIT APART STAAT VAN duwen()
     duwen() schrijft het lijstje naar het ACCOUNT en doet dus alleen iets voor wie is ingelogd.
     Dat is de kleinste groep: op 27-09-2026 had van 827 klanten niemand een lijstje behalve twee
     eigen testaccounts, terwijl niemand kon zeggen of er honderd gasten op het hartje hadden
     geklikt of nul. Een gastenlijstje verlaat de browser namelijk nooit.

     Deze teller loopt wel voor iedereen. Hij stuurt alleen wat een teller nodig heeft -- welke
     actie, welk product, ingelogd ja of nee -- en geen enkel gegeven dat tot een persoon te
     herleiden is.

     BEST EFFORT, ALTIJD. Een teller die stukgaat mag de knop niet meeslepen: alles in een
     try/catch, geen then, geen wachten. Werkt de tool niet, dan werkt het lijstje gewoon door.

     keepalive, want iemand die het hartje aanklikt en meteen doorklikt is anders weg voordat het
     verzoek de deur uit is. */
  function meet(actie, id) {
    try {
      var A = window.PWVerlanglijstAccount;
      var body = JSON.stringify({
        actie: actie,
        product_id: String(id || ''),
        ingelogd: !!(A && A.handtekening),
        shop: WINKEL
      });
      fetch(METING_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true,
        mode: 'cors'
      }).catch(function () { /* stil: dit is een teller, geen functie */ });
    } catch (e) { /* idem */ }

    /* Clarity draait al op de winkel en kan sessies terugspelen waarin dit gebeurde. Dat is iets
       anders dan de teller hierboven: daar zie je HOEVEEL, hier zie je WAT iemand deed. */
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', 'verlanglijst-' + actie);
      }
    } catch (e) { /* Clarity geblokkeerd door een adblocker: niet erg */ }
  }

  function lees() {
    try {
      var ruw = window.localStorage.getItem(SLEUTEL);
      var lijst = ruw ? JSON.parse(ruw) : [];
      return Array.isArray(lijst) ? lijst.filter(function (x) { return x && x.id; }) : [];
    } catch (e) {
      return [];
    }
  }

  function schrijf(lijst) {
    try {
      window.localStorage.setItem(SLEUTEL, JSON.stringify(lijst));
    } catch (e) {
      /* vol of geblokkeerd: dan gaat het lijstje deze sessie niet mee, maar breekt er niets */
    }
    document.dispatchEvent(new CustomEvent(GEBEURTENIS, { detail: { aantal: lijst.length } }));
    duwen();
  }

  function bevat(id) {
    return lees().some(function (x) { return String(x.id) === String(id); });
  }

  function wissel(item) {
    var lijst = lees();
    var i = lijst.findIndex(function (x) { return String(x.id) === String(item.id); });
    var weg = leesWeg();
    if (i === -1) {
      lijst.unshift({ id: String(item.id), handle: item.handle || '', titel: item.titel || '',
                      op: nu() });
      delete weg[String(item.id)];
    } else {
      lijst.splice(i, 1);
      weg[String(item.id)] = nu();
    }
    schrijfWeg(weg);
    schrijf(lijst);
    return i === -1;
  }

  /* WAAROM EEN VERWIJDERING EEN SPOOR ACHTERLAAT
     Zonder spoor kan koppel() bij de volgende paginalading niet zien of een product "nooit op het
     lijstje stond" of "er net afgehaald is". Het account zegt dan nog dat het erop staat, en dan
     komt het terug — precies wat er gebeurde als iemand iets weghaalde en binnen de wachttijd
     doorklikte. De grafsteentjes gaan weg zodra de server ze verwerkt heeft. */
  function leesWeg() {
    try {
      var ruw = window.localStorage.getItem(WEG_SLEUTEL);
      var o = ruw ? JSON.parse(ruw) : {};
      return (o && typeof o === 'object' && !Array.isArray(o)) ? o : {};
    } catch (e) { return {}; }
  }

  function schrijfWeg(o) {
    try { window.localStorage.setItem(WEG_SLEUTEL, JSON.stringify(o)); } catch (e) { /* zie schrijf() */ }
  }

  function verwijder(id) {
    var weg = leesWeg();
    weg[String(id)] = nu();
    schrijfWeg(weg);
    schrijf(lees().filter(function (x) { return String(x.id) !== String(id); }));
  }

  /* Handle of titel van één regel herstellen. Gebruikt door de lijstpagina zodra die merkt dat een
     bewaarde handle niet meer klopt — bijvoorbeeld omdat het product op de Franse winkel op het
     lijstje kwam en nu op de Nederlandse wordt bekeken. Vuurt met opzet GEEN gebeurtenis af: er
     verandert niets aan wat er op het lijstje staat, alleen aan hoe we het terugvinden. */
  function bijwerken(id, velden) {
    var lijst = lees();
    var i = lijst.findIndex(function (x) { return String(x.id) === String(id); });
    if (i === -1) return false;
    Object.keys(velden || {}).forEach(function (k) {
      if (velden[k]) lijst[i][k] = velden[k];
    });
    try {
      window.localStorage.setItem(SLEUTEL, JSON.stringify(lijst));
    } catch (e) { /* zie schrijf() */ }
    return true;
  }

  var VL = { lees: lees, bevat: bevat, wissel: wissel, verwijder: verwijder, bijwerken: bijwerken,
             gebeurtenis: GEBEURTENIS, aantal: function () { return lees().length; },
             /* teken() is er voor knoppen die ná het opstarten zijn gemaakt — op een gedeeld
                lijstje worden de regels immers pas gebouwd als Shopify heeft geantwoord. */
             teken: function () { tekenAlles(); } };
  window.PWVerlanglijst = VL;

  /* ---- koppeling met het klantaccount ---- */

  var KLANT_SLEUTEL = SLEUTEL + '_klant';   /* voor wie dit lijstje het laatst is bijgewerkt */
  var SYNC_SLEUTEL  = SLEUTEL + '_sync';    /* wanneer de server het voor het laatst heeft gekregen */
  var wachtend = null;

  function nu() { return Date.now(); }

  function haalUitOpslag(sleutel) {
    try { return window.localStorage.getItem(sleutel) || ''; } catch (e) { return ''; }
  }
  function zetInOpslag(sleutel, waarde) {
    try { window.localStorage.setItem(sleutel, String(waarde)); } catch (e) { /* zie schrijf() */ }
  }
  function ids(lijst) {
    return lijst.map(function (x) { return String(x.id); }).join(',');
  }

  /* Het lijstje naar de server duwen. Met een korte pauze, want wie drie hartjes achter elkaar
     aanklikt hoeft geen drie verzoeken te veroorzaken. Mislukt het, dan gebeurt er niets ergs:
     lokaal klopt het lijstje nog en de eerstvolgende wijziging probeert het opnieuw. */
  /* Wat heeft DEZE browser gedaan sinds de server voor het laatst iets van ons hoorde? Alleen
     dat gaat de deur uit. Het hele lijstje opsturen zou betekenen dat een onvolledig beeld —
     een privevenster, een product dat in deze markt niet bestaat, een tweede apparaat — stilletjes
     iets wist dat ergens anders wel op het lijstje staat. */
  function wijzigingen() {
    var sinds = parseInt(haalUitOpslag(SYNC_SLEUTEL), 10) || 0;
    var weg = leesWeg();
    return {
      erbij: lees().filter(function (x) { return !sinds || (x.op || 0) > sinds; })
                   .map(function (x) { return String(x.id); }),
      eraf: Object.keys(weg).filter(function (id) { return !sinds || weg[id] > sinds; })
    };
  }

  function pakket(A) {
    var w = wijzigingen();
    if (!w.erbij.length && !w.eraf.length) return null;
    return JSON.stringify({
      /* De winkel MOET mee. Zonder dit veld valt de server terug op zijn standaard en rekent hij
         de handtekening na met de sleutel van de verkeerde winkel: het verzoek wordt dan geweigerd
         en het lijstje van een ingelogde klant synchroniseert nooit. Het viel niet op zolang er
         één winkel was. */
      shop: WINKEL,
      klant_id: String(A.klant),
      geldig_tot: A.geldigTot,
      handtekening: A.handtekening,
      toevoegingen: w.erbij,
      verwijderingen: w.eraf
    });
  }

  /* Na een geslaagde verzending: de stempel op het moment van VERSTUREN zetten, niet op dat van
     het antwoord. Anders vallen wijzigingen die tussen die twee momenten zijn gemaakt buiten de
     volgende ronde en verdwijnen ze stil. */
  function gelukt(verstuurdOp) {
    zetInOpslag(SYNC_SLEUTEL, verstuurdOp);
    var weg = leesWeg(), over = {};
    Object.keys(weg).forEach(function (id) { if (weg[id] > verstuurdOp) over[id] = weg[id]; });
    schrijfWeg(over);
  }

  function duwen() {
    var A = window.PWVerlanglijstAccount;
    if (!A || !A.handtekening || !A.url) return;
    window.clearTimeout(wachtend);
    wachtend = window.setTimeout(function () {
      wachtend = null;
      var body = pakket(A);
      if (!body) return;
      var verstuurdOp = nu();
      fetch(A.url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
        .then(function (r) { if (r.ok) gelukt(verstuurdOp); })
        .catch(function () { /* offline of server plat: volgende wijziging probeert opnieuw */ });
    }, 800);
  }

  /* Wie iets weghaalt en meteen doorklikt, sluit het tabblad voordat die 800 ms om zijn. Dan gaat
     de wijziging alsnog mee: sendBeacon overleeft het wegnavigeren, fetch niet. */
  function nuDirect() {
    if (!wachtend) return;
    window.clearTimeout(wachtend);
    wachtend = null;
    var A = window.PWVerlanglijstAccount;
    if (!A || !A.handtekening || !A.url) return;
    var body = pakket(A);
    if (!body) return;
    var verstuurdOp = nu();
    try {
      if (navigator.sendBeacon &&
          navigator.sendBeacon(A.url, new Blob([body], { type: 'application/json' }))) {
        gelukt(verstuurdOp);
      }
    } catch (e) { /* dan blijft de wijziging staan tot de volgende keer */ }
  }

  window.addEventListener('pagehide', nuDirect);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') nuDirect();
  });

  /* Het lijstje uit de browser en het lijstje bij de klant bij elkaar brengen.
     De regel is: de server weet het beter, behalve voor wat er in déze browser is bijgekomen sinds
     hij voor het laatst met de server gepraat heeft. Alleen zo blijft een verwijdering op de
     telefoon ook op de laptop weg, terwijl wat je als gast verzamelde niet verdampt zodra je
     inlogt. Logt er een ándere klant in op dezelfde computer, dan gaat er niets van de vorige mee. */
  function koppel() {
    var A = window.PWVerlanglijstAccount;
    if (!A || !A.klant) return;

    var klant = String(A.klant);
    var vorige = haalUitOpslag(KLANT_SLEUTEL);
    var laatsteSync = parseInt(haalUitOpslag(SYNC_SLEUTEL), 10) || 0;
    var lokaal = lees();
    var weg = leesWeg();

    if (vorige && vorige !== klant) {
      /* Andere klant op dezelfde computer: niets van de vorige meenemen. */
      lokaal = []; weg = {}; laatsteSync = 0;
      schrijfWeg(weg);
    }

    var vanAccount = (A.lijst || []).map(function (p) {
      return { id: String(p.id), handle: p.handle || '', titel: p.titel || '', op: 0 };
    });

    var eigenNieuw = lokaal.filter(function (x) { return !laatsteSync || (x.op || 0) > laatsteSync; });
    var wegNu = {};
    Object.keys(weg).forEach(function (id) {
      if (!laatsteSync || weg[id] > laatsteSync) wegNu[id] = true;
    });

    var samen = eigenNieuw.slice();
    function erbij(p) {
      var id = String(p.id);
      if (wegNu[id]) return;
      if (!samen.some(function (x) { return String(x.id) === id; })) samen.push(p);
    }
    vanAccount.forEach(erbij);

    /* Kon Liquid niet alles ophalen — een product dat in deze markt niet verkocht wordt, of dat
       op concept staat — dan bewijst de accountlijst niets over wat er NIET in staat. Dan laten
       we staan wat hier stond. Is hij wel volledig, dan is een regel die hier wel en daar niet
       staat op een ander apparaat weggehaald, en hoort hij ook hier te verdwijnen. */
    if (A.onvolledig) lokaal.forEach(erbij);

    zetInOpslag(KLANT_SLEUTEL, klant);

    if (ids(samen) !== ids(lokaal)) {
      schrijf(samen);   /* werkt de opslag bij, tekent de hartjes opnieuw en duwt door */
    } else {
      duwen();          /* lokaal klopte al; er kan nog wel iets klaarstaan voor de server */
    }
  }

  /* ---- knoppen ---- */

  function tekenKnop(knop) {
    var erin = bevat(knop.getAttribute('data-pwvl-id'));
    knop.setAttribute('aria-pressed', erin ? 'true' : 'false');
    knop.classList.toggle('pwvl-knop--erin', erin);
    var label = knop.querySelector('[data-pwvl-label]');
    if (label) {
      label.textContent = erin ? knop.getAttribute('data-pwvl-erin') : knop.getAttribute('data-pwvl-eraf');
    }
  }

  function tekenAlles() {
    document.querySelectorAll('[data-pwvl-id]').forEach(tekenKnop);
    document.querySelectorAll('[data-pwvl-teller]').forEach(function (el) {
      var n = VL.aantal();
      el.textContent = n > 0 ? String(n) : '';
      el.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest ? e.target.closest('[data-pwvl-id]') : null;
    if (!knop) return;
    e.preventDefault();
    /* wissel() geeft true terug als het product ERBIJ kwam, false als het eraf ging. */
    var toegevoegd = wissel({
      id: knop.getAttribute('data-pwvl-id'),
      handle: knop.getAttribute('data-pwvl-handle'),
      titel: knop.getAttribute('data-pwvl-titel')
    });
    meet(toegevoegd ? 'toevoegen' : 'verwijderen', knop.getAttribute('data-pwvl-id'));
  });

  document.addEventListener(GEBEURTENIS, tekenAlles);

  /* Terug-navigatie uit de bfcache, en een lijstje dat in een ander tabblad is gewijzigd. */
  document.addEventListener('on:bfcache:load-restore', tekenAlles);
  window.addEventListener('pageshow', function (e) { if (e.persisted) tekenAlles(); });
  window.addEventListener('storage', function (e) { if (!e.key || e.key === SLEUTEL) tekenAlles(); });

  function opstarten() { tekenAlles(); koppel(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', opstarten);
  } else {
    opstarten();
  }
})();
